import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "title", "open", "onCancel", "onOk", "okText", "cancelText", "okDisabled", "cancelDisabled", "okLoading"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { AppModal } from './modal.component';
import { PrimaryButton, SecondaryButton } from '../button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(AppModal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 2px solid transparent;\n  .ant-modal-footer {\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n  }\n"])));
export var InputModal = function InputModal(_ref) {
  var children = _ref.children,
      title = _ref.title,
      open = _ref.open,
      onCancel = _ref.onCancel,
      onOk = _ref.onOk,
      okText = _ref.okText,
      cancelText = _ref.cancelText,
      okDisabled = _ref.okDisabled,
      cancelDisabled = _ref.cancelDisabled,
      okLoading = _ref.okLoading,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(StyledModal, _objectSpread(_objectSpread({}, rest), {}, {
    title: title,
    open: open,
    onCancel: onCancel,
    footer: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        size: "middle",
        disabled: cancelDisabled,
        onClick: onCancel,
        children: cancelText
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        loading: okLoading,
        disabled: okDisabled,
        onClick: onOk,
        children: okText
      })]
    }),
    children: children
  }));
};
InputModal.defaultProps = {
  okText: 'Save',
  cancelText: 'Cancel'
};